import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Content } from '../../../text';
import { LoadingIndicator } from '../../base';
import { ComponentIcons } from '../../icon';
import { NumberWrapper, StepDivider } from './styles';
import { ItemWrapper } from '../../tabs/OptionTabs/styles';

interface Props {
  to?: string;
  testId?: string;
  number?: number;
  text: string;
  divider?: boolean;
  active?: boolean;
  disabled?: boolean;
  visited?: boolean;
  invalid?: boolean;
  verifying?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const Step = ({
  to,
  divider,
  disabled = false,
  text,
  active = false,
  visited = false,
  invalid = false,
  verifying,
  testId,
  onClick,
}: Props): JSX.Element => {
  let StepIndicator = null;
  const history = useHistory();

  const handleClick = useCallback(
    (e: React.MouseEvent<any>) => {
      if (to) {
        history.push(to);
      }
      if (onClick) {
        onClick(e);
      }
    },
    [to, history, onClick]
  );

  if (visited) {
    StepIndicator = null;
  } else {
    StepIndicator = invalid ? (
      <ComponentIcons.Error fill={'var(--error-error)'} />
    ) : null;
  }

  if (verifying) {
    StepIndicator = <LoadingIndicator />;
  }

  return (
    <>
      {divider && <StepDivider />}

      <ItemWrapper
        as="button"
        key="step"
        className={disabled ? 'disabled' : ''}
        data-test-id={testId}
        selected={active}
        onClick={!disabled ? handleClick : undefined}
      >
        {StepIndicator && <NumberWrapper>{StepIndicator}</NumberWrapper>}

        <Content>{text}</Content>
      </ItemWrapper>
    </>
  );
};

export default Step;
